import Vue from 'vue'
import App from './App.vue'
import { MdField, MdContent, MdButton, MdCard } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.config.productionTip = false

Vue.use(MdField)
Vue.use(MdContent)
Vue.use(MdButton)
Vue.use(MdCard)

new Vue({
  render: h => h(App),
}).$mount('#app')
